module.exports = __webpack_public_path__ + "static/img/产品中心-井下智能防爆终端-本地化算力赋能.51221d4b.jpg";